import { render, staticRenderFns } from "./demoForm.vue?vue&type=template&id=4d3926a8&"
import script from "./demoForm.vue?vue&type=script&lang=js&"
export * from "./demoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports